var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('LoginForm',{on:{"success":_vm.continueToOrders}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }